import { Body } from "Components/Body";
import { useAuthState } from "Components/Logics/ensoCommonFunctions";
import CaseDetails from "Components/Content/CaseDetailsPage/CaseDetails";
import { EmptyState } from "Components/Content/EmptyState";
import { FindCase } from "Components/Content/CaseDetailsPage/FindCase";
import Header from "Components/Header";
import { STATUS } from "Components/Misc/CaseDetails_System";
import React, { memo, useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "Store/mainStore";
import DialogModal from "Components/Elements/DialogModal";
// import useDatamart from "Components/Content/configurationArea/Configurator/hooks/useDatamart";
// import { setDatamartUserRole } from "Store/general/auth";

const Home = () => {
  const caseDetailsSelector = useSelector(
    (state: RootState) => state.caseDetails
  );
  const authSelector = useSelector((state: RootState) => state.authSlice);
  const themeSelector = useSelector((state: RootState) => state.theme);
  const [showRedirectDialog, setShowRedirectDialog] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState<string>('');
  
  useAuthState();

  // Redirect to URL from environment variable on component mount
  useEffect(() => {
    const envRedirectUrl = process.env.REACT_APP_BH_REDIRECT_URL;
    if (envRedirectUrl) {
      setRedirectUrl(envRedirectUrl);
      setShowRedirectDialog(true);

      // Show dialog for 10 seconds then redirect
      const redirectTimer = setTimeout(() => {
        window.location.href = envRedirectUrl;
      }, 10000);

      // Cleanup timer if component unmounts
      return () => clearTimeout(redirectTimer);
    }
  }, []);

  return (
    <>
      <DialogModal
        isOpen={showRedirectDialog}
        type="popup"
        popInfo={{
          title: 'Redirecting...',
          msg: `DOT has been successfully migrated to the Business Hub Portal. You will be automatically redirected to the new platform in a few moments!!`,
          variant: 'CONFIRM'
        }}
        actionBtns={[]}
      >
        <div style={{ marginTop: '1rem' }}>
          <p style={{ margin: 0, marginBottom: '0.5rem' }}>
            <strong>Please note direct link for future use:</strong>
          </p>
          <a 
            href={process.env.REACT_APP_BH_REDIRECT_URL || redirectUrl}
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: '#0066cc', 
              textDecoration: 'underline',
              wordBreak: 'break-all',
              fontSize: '14px'
            }}
          >
            {process.env.REACT_APP_BH_REDIRECT_URL || redirectUrl}
          </a>
        </div>
      </DialogModal>
      <LoadingOverlay
        active={authSelector.system.isLoading}
        className="scroll"
        spinner
        classNamePrefix="MyLoader_"
        text="Please wait "
      >
        <Header />
        <Body
          crumbs={[
            caseDetailsSelector.data.caseName
              ? "Create case: " + caseDetailsSelector.data.caseName
              : "Create case",
          ]}
          bodyContent={
            <>
              {
                <div style={{ display: "grid", height: '100%' }}>
                  <div >
                    <FindCase />
                  </div>
                  <div>
                    {caseDetailsSelector.status === STATUS.IDLE ? (
                      <>
                        <div>

                          {themeSelector.data.stack.isOnline ? (
                            <CaseDetails />
                          ) : (
                            <EmptyState
                              src="/assets/images/WentWrong.svg"
                              msg="Something went wrong !" />
                          )}
                        </div>

                        {/* <PortPlans /> */}
                      </>
                    ) : (
                      <EmptyState
                        title="Nothing to show"
                        src="/assets/images/nothing-to-show.svg"
                        msg="Select the required criteria with valid sCRM Opportunity ID to proceed further"
                      />
                    )}
                  </div>
                </div>
              }

            </>
          }
        />


      </LoadingOverlay>
    </>
  );
};

export default memo(Home);

/*
 
*/
